
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/appeal",
      function () {
        return require("private-next-pages/appeal.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/appeal"])
      });
    }
  